// The visitor's answer to the cookie banner: "granted" or "denied". index.html
// reads the same key before the Google, Meta and PostHog tags start, so they
// begin in the right mode; setCookieConsent switches them when it changes.
export const COOKIE_CONSENT_KEY = "cookie-consent";
export const OPEN_COOKIE_SETTINGS_EVENT = "open-cookie-settings";

// Cookies those tags set on our domain, removed when consent is withdrawn.
const TRACKING_COOKIE = /^(_ga|_gcl_|_fbp|_fbc|ph_)/;

export function getCookieConsent() {
    try {
        return localStorage.getItem(COOKIE_CONSENT_KEY);
    } catch {
        return null;
    }
}

export function setCookieConsent(consent) {
    try {
        localStorage.setItem(COOKIE_CONSENT_KEY, consent);
    } catch {
        // Without storage the choice still applies until the page is reloaded.
    }

    const granted = consent === "granted";
    const state = granted ? "granted" : "denied";
    window.gtag?.("consent", "update", {
        ad_storage: state,
        ad_user_data: state,
        ad_personalization: state,
        analytics_storage: state,
    });
    window.fbq?.("consent", granted ? "grant" : "revoke");
    window.posthog?.set_config?.({
        persistence: granted ? "localStorage+cookie" : "memory",
    });

    if (!granted) deleteTrackingCookies();
}

// Lets the footer's "Cookie settings" link reopen the banner.
export function openCookieSettings() {
    window.dispatchEvent(new Event(OPEN_COOKIE_SETTINGS_EVENT));
}

function deleteTrackingCookies() {
    const rootDomain = window.location.hostname.replace(/^www\./, "");
    document.cookie
        .split(";")
        .map((cookie) => cookie.split("=")[0].trim())
        .filter((name) => TRACKING_COOKIE.test(name))
        .forEach((name) => {
            // The tags set them on the root domain; a plain delete misses those.
            for (const domain of ["", `; domain=.${rootDomain}`]) {
                document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domain}`;
            }
        });

    try {
        Object.keys(localStorage)
            .filter((key) => key.startsWith("ph_"))
            .forEach((key) => localStorage.removeItem(key));
    } catch {
        // Nothing to clean up without storage.
    }
}
